import React from 'react';
import { BookCover } from './BookCover';
import { PRODUCT_MOCKUP, PRODUCT_MOCKUP_ALT } from '../data/product';
const volumes: {
  n: string;
  title: string;
  accent: string;
}[] = [{
  n: '01',
  title: 'Foundations & Safe Landings',
  accent: 'bg-gold'
}, {
  n: '02',
  title: 'Vaults & Obstacle Skills',
  accent: 'bg-teal'
}, {
  n: '03',
  title: 'Jumps, Precision & Drops',
  accent: 'bg-gold'
}, {
  n: '04',
  title: 'Walls, Climbing & Bars',
  accent: 'bg-teal'
}, {
  n: '05',
  title: 'Flow, Lines & Creativity',
  accent: 'bg-gold'
}, {
  n: '06',
  title: "The Coach's Control Room",
  accent: 'bg-teal'
}];
type ProductStackProps = {
  className?: string;
  lazy?: boolean;
};

/**
 * Shows the real mockup when PRODUCT_MOCKUP is set; otherwise a code-drawn
 * six-volume box set in the pack's visual identity.
 */
export function ProductStack({
  className = '',
  lazy = false
}: ProductStackProps) {
  if (PRODUCT_MOCKUP) {
    return <img src={PRODUCT_MOCKUP} alt={PRODUCT_MOCKUP_ALT} width={1024} height={1024} loading={lazy ? 'lazy' : undefined} className={`mx-auto aspect-square w-full rounded-2xl object-cover shadow-book ring-1 ring-white/10 ${className}`} data-id="element-194" data-mp="113ciamnpvlxk" />;
  }
  return <div role="img" aria-label={PRODUCT_MOCKUP_ALT} className={`mx-auto grid w-full grid-cols-3 gap-2.5 sm:gap-4 ${className}`} data-id="element-195" data-mp="1a14i1q2yei7o">
      {volumes.map((v, i) => <BookCover key={v.n} kicker={`Volume ${v.n}`} number={v.n} title={v.title} accent={v.accent} size="sm" className={i % 2 === 0 ? '-rotate-1' : 'translate-y-3 rotate-1'} data-id="element-196" data-mp="21qh2y2tzwndc" data-mpi={i} />)}
    </div>;
}